export const FIRST_COLUMN_ID = '1'
export const SECOND_COLUMN_ID = '2'
